module.exports = __webpack_public_path__ + "img/pr-4.cb0f1136.png";